import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { oneOf, oneOfType, shape, string, number, instanceOf } from 'prop-types';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LoadingState = {
  INITIAL: 'INITIAL',
  FETCH: 'FETCH',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
function asyncField() {
  return {
    loadingState: LoadingState.INITIAL,
    error: undefined
  };
}
function fetch(field) {
  return _objectSpread(_objectSpread({}, field), {}, {
    loadingState: LoadingState.FETCH
  });
}
function success(field, data) {
  var obj = _objectSpread(_objectSpread({}, field), {}, {
    loadingState: LoadingState.SUCCESS
  });
  if (data) {
    return Object.assign(obj, data);
  }
  return obj;
}
function error(field, exception, errorCode) {
  return _objectSpread(_objectSpread({}, field), {}, {
    loadingState: LoadingState.ERROR,
    error: exception,
    errorCode: errorCode
  });
}
var loadingStateShape = oneOf(Object.keys(LoadingState));
var errorShape = oneOfType([shape({
  message: string.isRequired,
  errorCode: number.isRequired
}), instanceOf(Error)]);
var asyncFieldShape = shape({
  loadingState: loadingStateShape,
  error: errorShape
});

export { LoadingState, asyncField, asyncFieldShape, error, errorShape, fetch, loadingStateShape, success };
